import { t as uiText } from '../../i18n';
import {
  generatePublicApiToken,
  updatePublicApiToken,
  type PublicApiToken,
} from '../../api/publicApiTokens';
import { findReadyEmbedToken, normalizeSiteOrigin } from './embedSecurityState';

export { findReadyEmbedToken, normalizeSiteOrigin };

export async function registerEmbedSite(
  workspaceId: string,
  siteUrl: string,
  tokens: PublicApiToken[],
): Promise<void> {
  const origin = normalizeSiteOrigin(siteUrl);
  const active = tokens.find((token) => token.isActive);
  if (!active) {
    await generatePublicApiToken({
      workspaceId,
      allowedOrigins: [origin],
      note: uiText("Host site"),
    });
    return;
  }
  if (active.allowedOrigins.includes(origin)) return;
  await updatePublicApiToken({
    tokenId: active.id,
    allowedOrigins: [...active.allowedOrigins, origin],
  });
}

export async function removeEmbedSite(
  origin: string,
  tokens: PublicApiToken[],
): Promise<void> {
  const active = findReadyEmbedToken(tokens);
  if (!active) return;
  const allowedOrigins = active.allowedOrigins.filter((item) => item !== origin);
  if (allowedOrigins.length === active.allowedOrigins.length) return;
  await updatePublicApiToken({
    tokenId: active.id,
    allowedOrigins,
  });
}
